import React, { useMemo } from 'react';
import cx from 'classnames';

import { useBreakpoint } from '../misc/Breakpoints/Breakpoints';
import { BreakpointKey } from '../misc/Breakpoints/Breakpoints.d';

import styles from './ConfettiOverlay.scss';

const getConfettiLength = (breakpointMobile: boolean, breakpointTablet: boolean) => {
  if (breakpointMobile) {
    return 44;
  }
  if (breakpointTablet) {
    return 71;
  }
  return 143;
};

interface ConfettiOverlayProps {
  loop?: boolean;
}

export const ConfettiOverlay = ({ loop = true }: ConfettiOverlayProps) => {
  const {
    maxWidth: {
      [BreakpointKey.BREAKPOINT_MOBILE]: breakpointMobile,
      [BreakpointKey.BREAKPOINT_TABLET]: breakpointTablet,
    },
  } = useBreakpoint();

  const confettiArr = useMemo(
    () =>
      Array.from({ length: getConfettiLength(breakpointMobile, breakpointTablet) }, (_, i) => i),
    [breakpointMobile, breakpointTablet],
  );

  return (
    <div
      className={styles.overlay}
      data-testid="animated-confetti-overlay"
      style={{ '--confetti-len': confettiArr.length } as React.CSSProperties}
    >
      {confettiArr.map((it) => (
        <div
          key={it}
          className={cx(
            styles.confetti,
            styles[`confetti-${it + 1}`],
            { [styles.confettiNoLoop]: !loop },
          )}
          data-testid="confetti-element"
        >
          <div className={styles.rotate}>
            <div className={styles.askew} />
          </div>
        </div>
      ))}
    </div>
  );
};
